import { Injectable } from '@angular/core';
import { AlertifyService } from './alertify.service';
import * as _ from 'lodash';
import { ExportFileResponse } from '../../models/rest/common/export-file-response';
import html2pdf from 'html2pdf.js';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private alertifyService: AlertifyService) { }


  checkImageFile(file: any) {
    const fileName = file.name;
    // Size Filter Bytes
    const max_size = 3000000;
    const allowed_types = ['image/png', 'image/jpg', 'image/jpeg', 'image/webp'];
    const max_height = 15200;
    const max_width = 25600;

    if (file.size > max_size) {

      this.alertifyService.error(fileName + " -> " +
        'Maximum size allowed is ' + max_size / 1000 / 1000 + 'MB');

      return false;
    }

    if (!_.includes(allowed_types, file.type)) {
      this.alertifyService.error(fileName + " -> " + 'Only Images are allowed ( JPG | JPEG | PNG | WEBP )');
      return false;
    }

    return true;

  }

  base64ToBlob(base64: string, contentType: string = 'application/pdf', sliceSize: number = 512): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }


  byteArrayToBlob(byteArray: number[], contentType: string = 'application/pdf'): Blob {
    const uint8Array = new Uint8Array(byteArray);
    return new Blob([uint8Array.buffer], { type: contentType });
  }


  // Blob kullanarak dosya indirme işlemi
  downloadFile(blob: Blob, fileName: string) {
    const pdfUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = fileName; // Sunucudan gelen dosya adını kullanarak indir
    link.click();

    URL.revokeObjectURL(pdfUrl); // URL'yi temizle
  }

  downloadFileWithResponse(response: ExportFileResponse) {
    const pdfBlob = this.base64ToBlob(response.data);
    this.downloadFile(pdfBlob, response.fileName);
  }

  downloadMultipleFiles(fileBlobs: { blob: Blob; fileName: string }[]) {
    fileBlobs.forEach((file, index) => {
      setTimeout(() => {
        this.downloadFile(file.blob, file.fileName);
      }, index * 500); // 500ms aralıklarla dosyaları indir
    });
  }
  previewBLOB(blob: Blob): void {

    // Blob'dan bir URL oluştur
    const url = URL.createObjectURL(blob);

    // Yeni bir sekmede aç
    window.open(url, '_blank');
  }

  htmlToPdf(htmlContent: string, fileName: string = 'document.pdf'): Promise<void> {
    return new Promise((resolve, reject) => {
      const element = document.createElement('div');
      element.innerHTML = htmlContent;
      element.style.width = '210mm';
      element.style.minHeight = '297mm';
      element.style.padding = '10mm';
      element.style.backgroundColor = 'white';

      document.body.appendChild(element);

      const opt = {
        margin: 0,
        filename: fileName,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          letterRendering: true
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait'
        }
      };

      html2pdf().set(opt).from(element).save().then(() => {
        document.body.removeChild(element);
        resolve();
      }).catch((error) => {
        document.body.removeChild(element);
        reject(error);
      });
    });
  }

}
